import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import style from './Hero.module.scss';
import classNames from 'classnames';

const Hero = ({ primary, sliceType, togglePeriod, isMobile }) => {
  // const [isMobile, setIsMobile] = useState(false);

  const { title, subtitle } = primary;

  // const togglePeriod = () => {
  //   setIsMobile(!isMobile);
  // };

  return (
    <div className={style.wrapper}>
      {sliceType === 'hero_business' ? (
        <div className={style.container}>
          <div className={style.title}>
            <RichText render={title.richText} />
          </div>
          <label className={style.label}>
            <input type="checkbox" checked={isMobile} onChange={togglePeriod} />
            <span
              className={classNames(style.icon, {
                [style.selected]: !isMobile,
              })}
            >
              {isMobile ? 'Web' : 'Mobile'}
            </span>
            <span
              className={classNames(style.pointer, {
                [style.selected]: isMobile,
              })}
            >
              {isMobile ? 'Mobile' : 'Web'}
            </span>
          </label>
          <div className={style.description}>
            <RichText render={subtitle.richText} />
          </div>
        </div>
      ) : (
        <div className={style.container}>
          {/* <div className={style.description}>
            <RichText render={subtitle.richText} />
          </div> */}
        </div>
      )}
    </div>
  );
};

Hero.propTypes = {
  sliceType: PropTypes.string,
  primary: PropTypes.object.isRequired,
  togglePeriod: PropTypes.func,
  isMobile: PropTypes.bool,
};

export default Hero;
